module.exports = __webpack_public_path__ + "static/media/addUser.aaf5f109.svg";